import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'ui-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrl: './selectable-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-cy]': 'dataCy() || null',
  },
})
export class SelectableCardComponent {
  label = input<string>('');
  // Bootstrap icon name without the `bi-` prefix, e.g. 'bookmark-fill'.
  icon = input<string>('');
  selected = input<boolean>(false);
  dataCy = input<string>('');
  toggleSelect = output<void>();
}
